import { observable, action } from 'mobx';
import agent from '../../api/agent';
import FollowersList from '../../components/artist/followersList';

export default new class artistDetailsStore {
    @observable limit =250;
    @observable offsetFollowers = 0;
    @observable offsetFollowing = 0;

    @action followTheArtist(id) {
        return agent.FollowAndUnfollow.followTheUser(id)
    }
    @action unFollowTheArtist(id) {
        return agent.FollowAndUnfollow.unFollowTheUser(id)
    }

    @action followersList(id) {
        return agent.FollowAndUnfollow.followersList(id, { limit: this.limit, offset: this.offsetFollowers })
    }
    @action followingList(id) {
        return agent.FollowAndUnfollow.followingList(id, { limit: this.limit, offset: this.offsetFollowing })
    }
    @action loadMore(followers, following) {
        if (followers) {
            this.offsetFollowers = this.offsetFollowers + this.limit
        } else {
            this.offsetFollowing = this.offsetFollowing + this.limit

        }
    }
    @action reset(followers, following) {
        // if (followers) {
            this.offsetFollowers = 0
        // } else {
            this.offsetFollowing = 0

        // }
    }
}


// WEBPACK FOOTER //
// ./src/stores/artistsStore/followAndLikeStore.js